var _rect, _rect2, _line, _line2, _line3, _line4, _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFq22(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.501172,
    y: 0.796094,
    width: 48.972,
    height: 48.972,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11.7375,
    y: 12.0305,
    width: 26.4993,
    height: 26.4993,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 38.325,
    y1: 12.1824,
    x2: 49.5613,
    y2: 0.946085,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 0.651149,
    y1: 49.8543,
    x2: 11.8875,
    y2: 38.618,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 38.0871,
    y1: 38.6199,
    x2: 49.3234,
    y2: 49.8562,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 0.413304,
    y1: 0.944118,
    x2: 11.6496,
    y2: 12.1804,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.714 30.23C19.4313 28.942 20.7567 27.7893 21.69 26.772C22.6327 25.7453 23.104 24.742 23.104 23.762C23.104 23.118 22.9407 22.6047 22.614 22.222C22.2967 21.83 21.774 21.634 21.046 21.634C20.3367 21.634 19.786 21.858 19.394 22.306C19.0113 22.7447 18.7967 23.3327 18.75 24.07H17.798C17.854 23.034 18.1713 22.2313 18.75 21.662C19.338 21.0833 20.1033 20.794 21.046 20.794C21.9513 20.794 22.684 21.0507 23.244 21.564C23.804 22.068 24.084 22.7867 24.084 23.72C24.084 24.8493 23.6127 25.946 22.67 27.01C21.7367 28.0647 20.584 29.096 19.212 30.104H24.392V30.93H17.714V30.23ZM25.7257 30.23C27.4431 28.942 28.7684 27.7893 29.7017 26.772C30.6444 25.7453 31.1157 24.742 31.1157 23.762C31.1157 23.118 30.9524 22.6047 30.6257 22.222C30.3084 21.83 29.7857 21.634 29.0577 21.634C28.3484 21.634 27.7977 21.858 27.4057 22.306C27.0231 22.7447 26.8084 23.3327 26.7617 24.07H25.8097C25.8657 23.034 26.1831 22.2313 26.7617 21.662C27.3497 21.0833 28.1151 20.794 29.0577 20.794C29.9631 20.794 30.6957 21.0507 31.2557 21.564C31.8157 22.068 32.0957 22.7867 32.0957 23.72C32.0957 24.8493 31.6244 25.946 30.6817 27.01C29.7484 28.0647 28.5957 29.096 27.2237 30.104H32.4037V30.93H25.7257V30.23Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFq22);
export default __webpack_public_path__ + "static/media/fq22.1363aa21776f62fd09e0b5e553bb2dff.svg";
export { ForwardRef as ReactComponent };